import { ViewList, LibraryBooks, Equalizer, NetworkCheck, Computer, Person, Lock, ManageAccounts, SmartToy,
        SupervisedUserCircle, ReceiptLong, Factory, Domain, Announcement, FactCheck,  DirectionsBoat, 
        SouthAmerica, Timeline as TimelineIcon, DonutSmall, Chat, SsidChart, BrowserUpdated, Settings, 
      } from '@mui/icons-material'


import { Mediateca } from './views/Mediateca'
import { DashboardSA } from './views/DashboardSA'
import { Servers } from './views/Servers'
import { Daemons } from './views/Daemons'
import { SysConfig } from './views/SysConfig'
import { Users } from './views/Users'
import { Permissions } from './views/Permissions'
import { AccessProfile } from './views/AccessProfile'
import { MyProfile } from './views/MyProfile'
import { Business } from './views/Business'
import { Sections } from './views/Sections'
import { AttentionWord } from './views/AttentionWord'
import { Fact } from './views/Fact'
import { Grupo } from './views/Group'
import { Embarcacoes } from './views/Embarcacoes'
import { Logs } from './views/Logs'
import { LastLogins } from './views/LastLogins'
import { TimelineClass } from './views/TimelineSA'
import { AlertGR } from './views/AlertGR'
import { AccessHist } from './views/AccessHist'

import { C, D } from './include'

export const navigation = [
  {
    id: 'mediateca',
    title: 'Mediateca',
    type: 'item',
    icon: <LibraryBooks sx={{ color: '#fff' }} />,
    component: <Mediateca />,
    url: '/mediateca',
    permission: '*',
  },
  {
    id: 'timeline',
    title: 'Linha do Tempo',
    type: 'item',
    icon: <TimelineIcon sx={{ color: '#fff' }} />,
    component: <TimelineClass />,
    url: '/TimelineSA',
    permission: 'TimeLine-Ler',
  },
  {
    id: 'IA',
    title: 'Chat IA',
    type: 'link',
    icon: <Chat sx={{ color: '#fff' }} />,
    url: 'http://10.21.45.169:3000/',
    permission: 'ChatIA-Ler',
  },
  {
    id: 'dashboard',
    title: 'Dashboards',
    type: 'collapse',
    icon: <Equalizer sx={{ color: '#fff' }} />,
    permission: 'Dashboard-Ler',
    children: [
      {
        id: 'indicadores',
        title: 'Indicadores',
        type: 'item',
        icon: <DonutSmall sx={{ color: '#fff' }} />,
        component: <DashboardSA />,
        url: '/DashboardSA',
        permission: 'Dashboard-Ler',  //
      },
      {
        id: 'alertas',
        title: 'Histórico de Alertas',
        type: 'item',
        icon: <SsidChart sx={{ color: '#fff' }} />,
        component: <AlertGR />,
        url: '/AlertGR',
        permission: 'Dashboard-Ler',  //
      },
	  ]
  },
  {
    id: 'register',
    title: 'Cadastros',
    type: 'collapse',
    icon: <ViewList sx={{ color: '#fff' }} />,
    permission: 'Cadastro-Ler',
    children: [
      {
        id: 'court',
        title: C.businessLabel,
        type: 'item',
        icon: <Factory sx={{ color: '#fff' }} />,
        component: <Business />,
        url: '/court',
        permission: 'Empresa-Ler',
      },
      {
        id: 'organization',
        title: C.divisionLabel,
        type: 'item',
        icon: <Domain sx={{ color: '#fff' }} />,
        component: <Sections />,
        url: '/section',
        permission: 'Departamento-Ler',
      },
      {
        id: 'attentionword',
        title: 'Palavras de Atenção',
        type: 'item',
        icon: <Announcement sx={{ color: '#fff' }} />,
        component: <AttentionWord />,
        url: '/attention',
        permission: 'Fato-Ler',
      },
      {
        id: 'fact',
        title: 'Fatos',
        type: 'item',
        icon: <FactCheck sx={{ color: '#fff' }} />,
        component: <Fact />,
        url: '/fact',
        permission: 'Fato-Ler',
      },
      {
        id: 'grupo',
        title: C.groupLabel,
        type: 'item',
        icon: <SouthAmerica sx={{ color: '#fff' }} />,
        component: <Grupo/>,
        url: '/grupo',
        permission: 'Fato-Ler',
      },
      {
        id: 'embarcacoes',
        title: 'Embarcações',          // Nome exibido no menu
        type: 'item',
        icon: <DirectionsBoat sx={{ color: '#fff' }} />, // Pode escolher outro ícone se quiser
        component: <Embarcacoes />,
        url: '/embarcacoes',
        permission: 'Fato-Ler',
      },
    ]
  },
  {
    id: 'user',
    title: 'Usuários',
    type: 'collapse',
    icon: <Person sx={{ color: '#fff' }} />,
    permission: 'Usuário-Ler',
    children: [
      {
        id: 'user',
        title: 'Cadastro',
        type: 'item',
        icon: <ManageAccounts sx={{ color: '#fff' }} />,
        component: <Users />,
        url: '/user',
        permission: 'Usuário-Ler',
      },
// historico de acesso
      {
        id: 'acchist',
        title: 'Histórico de Acessos',
        type: 'item',
        icon: <SsidChart sx={{ color: '#fff' }} />,
        component: <AccessHist />,
        url: '/accesshist',
        permission: 'Usuário-Ler',
      },
// logs de acessos
      {
        id: 'logs',
        title: 'Logs de Acesso',
        type: 'item',
        icon: <ReceiptLong sx={{ color: '#fff' }} />,
        component: <Logs />,
        url: '/logs',
        permission: 'Usuário-Ler',
      },
// sessoes ativas
      {
        id: 'active',
        title: 'Usuários Logados',
        type: 'item',
        icon: <BrowserUpdated sx={{ color: '#fff' }} />,
        component: <LastLogins />,
        url: '/lastlogins',
        permission: 'Usuário-Ler',
      }
	  ]
  },
  {
    id: 'permission',
    title: 'Permissões',
    type: 'item',
    icon: <Lock sx={{ color: '#fff' }} />,
    component: <Permissions />,
    url: '/permission',
    permission: 'Permissão-Ler',

  },
  {
    id: 'access-profile',
    title: 'Perfis de Acesso',
    type: 'item',
    icon: <SupervisedUserCircle sx={{ color: '#fff' }} />,
    component: <AccessProfile />,
    url: '/access-profile',
    permission: 'Perfil de Acesso-Ler',
  },
  {
    id: 'example-component',
    title: 'Painel de Controle',
    type: 'collapse',
    icon: <NetworkCheck sx={{ color: '#fff' }} />,
    permission: 'Painel de Controle-Ler',
    children: [
      {
        id: 'equipment',
        title: 'Equipamentos',
        type: 'item',
        icon: <Computer sx={{ color: '#fff' }} />,
        component: <Servers />,
        url: '/server',
        permission: 'Equipamento-Ler',
      },
      {
        id: 'daemons',
        title: 'Daemons',
        type: 'item',
        icon: <SmartToy sx={{ color: '#fff' }} />,
        component: <Daemons />,
        url: '/daemons',
        permission: 'Daemon-Ler',
      },
      {
        id: 'sysconfig',
        title: 'Configurações do Sistema',
        type: 'item',
        icon: <Settings sx={{ color: '#fff' }} />,
        component: <SysConfig />,
        url: '/sysconfig',
        permission: 'Config. Sistema-Ler',
      },
    ]
  },
  {
    id: 'myprofile',
    title: 'Meu Perfil',
    type: 'route',
    icon: null,
    component: <MyProfile />,
    url: '/profile',
    permission: '*'
  },
  {
    id: 'logout',
    title: 'Sair',
    type: 'route',
    icon: null,
    component: <D />,
    url: '/logout',
    permission: ''
  }
]
